module.exports = __webpack_public_path__ + "img/indexa.1369916c.svg";